module.exports = __webpack_public_path__ + "img/statue-of-liberty.2802ed27.jpg";